import { render, staticRenderFns } from "./addPlts.vue?vue&type=template&id=0af72906"
import script from "./addPlts.vue?vue&type=script&lang=js"
export * from "./addPlts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports